var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-nav-shell"},[_c(_setup.MobileNav,{attrs:{"brand-items":_setup.visibleBrandItems}}),_vm._v(" "),_c(_setup.DesktopNav),_vm._v(" "),(_setup.useProducts)?_c(_setup.Search):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }